module.exports = __webpack_public_path__ + "static/media/flag.ba437b86.svg";